var HulkappWishlist = {
    init: function () {
        customerID = window.hulkappsWishlist.customerID;
        hulkShopDomain = window.hulkappsWishlist.domain;
        customerStatus = 'Customer';
        DefaultWishlistID = [];
        wishlistProductsData = [];
        wishlistsData = [];
        wishlistBtnStyle = '';
        deactivatedStore = false;
        appStatus = false;
        hulkUserUUID = null;
        allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
        wishlistTotal = document.querySelector('[data-totalwishlistitems]');
        globalHulkDeleteWishlistPrompt = document.querySelectorAll("[data-hulkappsdeleteprompt]")[0];

        hulkSelectAll = document.querySelectorAll("[data-selectallwishlist]")[0];
        hulkSelectAllDrawer = document.querySelectorAll("[data-selectalldrawerwishlist]")[0];
        hulkSelectCheckbox = document.getElementById("hulk_select_all");
        hulkSelectCheckbox2 = document.getElementById("hulk_select_drawer_all");
        hulkMoveAllItems = document.querySelectorAll("[data-hulkmoveallitmes]")[0];
        hulkMoveAllDrawerItems = document.querySelectorAll("[data-hulkmoveallitmes]")[1];
        hulkDeleteAllItems = document.querySelectorAll("[data-hulkdeleteallitmes]")[0];
        hulkDeleteAllDrawerItems = document.querySelectorAll("[data-hulkdeleteallitmes]")[1];
        hulkDeleteWishlistItemsPrompt = document.querySelectorAll("[data-hulkappsDeleteItemsPrompt]")[0];
        hulkDeleteWishlistItems = document.querySelectorAll("[data-deleteHulkWishlistItems]")[0];
        hulkCloseDeleteWishlistItems = document.querySelectorAll("[data-closeWishlistItemsPopup]")[0];
        hulkCloseDeleteWishlistItems2 = document.querySelectorAll("[data-closeWishlistItemsPopup2]")[0];

        hulkMoveWishlistItemsPrompt = document.querySelectorAll('[data-hulkappsMoveItemsPrompt]')[0];
        hulkWishlistEmptyContainer =  document.querySelectorAll('[data-HulkEmptyWishlist]')[0];
        hulkWishlistEmptyContainerDrawer =  document.querySelectorAll('[data-HulkEmptyWishlist]')[1];
        hulkCloseMyWishlistPopup2 = document.querySelectorAll("[data-closemywishlistpopup2]")[0];
        hulkCloseMyWishlistDrawer2 = document.querySelectorAll("[data-closeMyWishlistDrawer2]")[0];
        proxyURL = '/'+window.hulkappsWishlist.generalSettings.app_proxy_prefix+'/'+window.hulkappsWishlist.generalSettings.app_proxy_path;
        iconAnimationStyles = '-webkit-animation: heart 1s cubic-bezier(0.17, 0.89, 0.32, 1.49); animation: heart 1s cubic-bezier(0.17, 0.89, 0.32, 1.49);';

        globalSelectedWishlistID = '';
        selectedMyWishlistProductIds = [];
        selectedMyWishlistVariantIds = [];
        moveMyWishlistProductIds = [];
        moveMyWishlistVariantIds = [];
        productsCount = 0;
        outStockProductsCount = 0;
        emptyIconStyle = '';
        fillIconStyle = '';
        emptyCollectionIconStyle = '';
        fillCollectionIconStyle = '';
        btnExtraStyle = '';
        countExtraStyle = '';
        searchWishlist = '';

        let guestWishlistData, wishlistButtonTarget;

        let hulkappsWishlistSettings = []
        hulkappsWishlistSettings['style'] = window.hulkappsWishlist.buttonStyleSettings;
        hulkappsWishlistSettings['general'] = window.hulkappsWishlist.generalSettings;
        hulkappsWishlistSettings['language'] = window.hulkappsWishlist.languageSettings;
        WishlistSettings = Object.assign({}, hulkappsWishlistSettings);

        HulkappWishlist._checkFOrInactiveStore();

        headerType = (WishlistSettings.style.header_type) ? WishlistSettings.style.header_type : 'header_menu';
        headerIconPosition = (WishlistSettings.style.header_icon_position) ? WishlistSettings.style.header_icon_position : 'manual_header_icon';
        headerIconDesign = (WishlistSettings.style.header_icon_design) ? WishlistSettings.style.header_icon_design : 'wishlist_page';

        saveForLaterType = (WishlistSettings.style.save_for_later_type) ? WishlistSettings.style.save_for_later_type : 'individual_button';
        saveForLaterPosition = (WishlistSettings.style.individual_button_position) ? WishlistSettings.style.individual_button_position : 'individual_button_manual';
        saveAllForLaterPosition = (WishlistSettings.style.global_button_position) ? WishlistSettings.style.global_button_position : 'global_button_manual';

        buttonLayout = (WishlistSettings.general.button_layout != undefined) ? WishlistSettings.general.button_layout : 'multi_color_button';
        collectionCountLayout = (WishlistSettings.style.collection_count_layout != undefined) ? WishlistSettings.style.collection_count_layout : 'top_count';

        iconType = (WishlistSettings.style.icon_type) ? WishlistSettings.style.icon_type : 'outline';
        iconFillColor = (WishlistSettings.style.icon_fill_color) ? WishlistSettings.style.icon_fill_color : '#ffffff';
        iconBorderColor = (WishlistSettings.style.icon_border_color) ? WishlistSettings.style.icon_border_color : '#ffffff';
        iconHoverColor = (WishlistSettings.style.icon_hover_color) ? WishlistSettings.style.icon_hover_color : '#5C6AC4';
        selectedIconFillColor = (WishlistSettings.style.selected_icon_fill_color) ? WishlistSettings.style.selected_icon_fill_color : '#ffffff';
        selectedIconBorderColor = (WishlistSettings.style.selected_icon_border_color) ? WishlistSettings.style.selected_icon_border_color : '#ffffff';
        iconBackgroundType = (WishlistSettings.style.icon_background_type) ? WishlistSettings.style.icon_background_type : 'icon_no_background';
        iconBackgroundColor = (WishlistSettings.style.icon_background_color) ? WishlistSettings.style.icon_background_color : '#ccc';
        iconSize = (WishlistSettings.style.icon_size) ? WishlistSettings.style.icon_size : '16px';
        isCustomizeProductIcon = (WishlistSettings.style.customize_product_icon) ? WishlistSettings.style.customize_product_icon : false;

        collectionIconType = (WishlistSettings.style.collection_icon_type) ? WishlistSettings.style.collection_icon_type : 'outline';
        collectionIconFillColor = (WishlistSettings.style.collection_icon_fill_color) ? WishlistSettings.style.collection_icon_fill_color : WishlistSettings.style.theme_color;
        collectionIconBorderColor = (WishlistSettings.style.collection_icon_border_color) ? WishlistSettings.style.collection_icon_border_color : WishlistSettings.style.theme_color;
        collectionIconHoverColor = (WishlistSettings.style.collection_icon_hover_color) ? WishlistSettings.style.collection_icon_hover_color : '#000';
        selectedCollectionIconFillColor = (WishlistSettings.style.collection_selected_icon_fill_color) ? WishlistSettings.style.collection_selected_icon_fill_color : WishlistSettings.style.theme_color;
        selectedCollectionIconBorderColor = (WishlistSettings.style.collection_selected_icon_border_color) ? WishlistSettings.style.collection_selected_icon_border_color : WishlistSettings.style.theme_color;
        collectionIconBackgroundType = (WishlistSettings.style.collection_icon_background_type) ? WishlistSettings.style.collection_icon_background_type : 'icon_no_background';
        collectionIconBackgroundColor = (WishlistSettings.style.collection_icon_background_color) ? WishlistSettings.style.collection_icon_background_color : '#ccc';
        collectionIconSize = (WishlistSettings.style.collection_icon_size) ? WishlistSettings.style.collection_icon_size : '16px';
        isCustomizeCollectionIcon = (WishlistSettings.style.customize_collection_icon) ? WishlistSettings.style.customize_collection_icon : false;

        if(WishlistSettings.style.button_style === 'style_2' || WishlistSettings.style.button_style === 'style_4') {
            if(WishlistSettings.general.public_wishlist_count === 'show') {
                if(buttonLayout === 'multi_color_button') {
                    btnExtraStyle = 'padding:  '+ WishlistSettings.style.button_top_bottom_vertical_space + 'px ' + WishlistSettings.style.button_left_right_vertical_space + 'px; border-radius: '+ WishlistSettings.style.button_border_radius + 'px 0 0 '+ WishlistSettings.style.button_border_radius + 'px;';
                    countExtraStyle = 'padding:  '+ WishlistSettings.style.button_top_bottom_vertical_space + 'px 10px; opacity: 0.5; border-radius: 0 '+ WishlistSettings.style.button_border_radius + 'px '+ WishlistSettings.style.button_border_radius + 'px 0;';
                } else {
                    btnExtraStyle = 'padding: ' + WishlistSettings.style.button_top_bottom_vertical_space+'px 0px ' + WishlistSettings.style.button_top_bottom_vertical_space+'px ' + WishlistSettings.style.button_left_right_vertical_space+'px; border-radius: '+ WishlistSettings.style.button_border_radius + 'px 0 0 '+ WishlistSettings.style.button_border_radius + 'px;';
                    countExtraStyle = 'padding: ' + WishlistSettings.style.button_top_bottom_vertical_space+'px ' + WishlistSettings.style.button_left_right_vertical_space+'px '+WishlistSettings.style.button_top_bottom_vertical_space+'px 5px; border-radius: 0 '+ WishlistSettings.style.button_border_radius + 'px '+ WishlistSettings.style.button_border_radius + 'px 0;';
                }
            } else {
                btnExtraStyle = 'padding:  '+ WishlistSettings.style.button_top_bottom_vertical_space + 'px ' + WishlistSettings.style.button_left_right_vertical_space + 'px; border-radius: '+ WishlistSettings.style.button_border_radius + 'px;';
                countExtraStyle = '';
            }
        }

        if(isCustomizeProductIcon) {
            if(iconType === 'both') {
                emptyIconStyle = '-webkit-text-stroke: 1px '+iconBorderColor+'; color: '+iconFillColor+';font-size: '+iconSize + 'px;';
                fillIconStyle = '-webkit-text-stroke-color: '+selectedIconBorderColor+'; -webkit-text-stroke-width: 1.5px;color: '+selectedIconFillColor+';font-size: '+iconSize + 'px;';
            } else {
                emptyIconStyle = 'color: '+iconFillColor+';font-size: '+iconSize + 'px;';
                fillIconStyle = 'color: '+selectedIconFillColor+';font-size: '+iconSize + 'px;';
            }

            if(iconBackgroundType != 'icon_no_background') {
                emptyIconStyle += 'background: '+iconBackgroundColor+';';
                fillIconStyle += 'background: '+iconBackgroundColor+';';
                if(iconBackgroundType === 'icon_round_background') {
                    emptyIconStyle += 'border-radius: 50%;';
                    fillIconStyle += 'border-radius: 50%;';
                }
            }
        }

        if(isCustomizeCollectionIcon) {
            if(collectionIconType === 'both') {
                emptyCollectionIconStyle = '-webkit-text-stroke: 1px '+collectionIconBorderColor+'; color: '+collectionIconFillColor+';font-size: '+collectionIconSize + 'px;';
                fillCollectionIconStyle = '-webkit-text-stroke-color: '+selectedCollectionIconBorderColor+'; -webkit-text-stroke-width: 1.5px;color: '+selectedCollectionIconFillColor+';font-size: '+collectionIconSize + 'px;';
            } else {
                emptyCollectionIconStyle = 'color: '+collectionIconFillColor+';font-size: '+collectionIconSize + 'px;';
                fillCollectionIconStyle = 'color: '+selectedCollectionIconFillColor+';font-size: '+collectionIconSize + 'px;'
            }

            if(isCustomizeCollectionIcon && collectionIconBackgroundType != 'icon_no_background') {
                emptyCollectionIconStyle += 'background: '+collectionIconBackgroundColor+';padding: 5px 7px;';
                fillCollectionIconStyle += 'background: '+collectionIconBackgroundColor+';padding: 5px 7px;';
                if(collectionIconBackgroundType === 'icon_round_background') {
                    emptyCollectionIconStyle += 'border-radius: 50%;';
                    fillCollectionIconStyle += 'border-radius: 50%;';
                }
            }
        }

        let isFloatingButton = (WishlistSettings.style.wl_floating_button) ? WishlistSettings.style.wl_floating_button : false;
        if(isFloatingButton && (WishlistSettings.style.hide_floating_button_mobile_version === false || (WishlistSettings.style.hide_floating_button_mobile_version === true && window.innerWidth > 768))) {
            if(proxyURL != window.location.pathname) {
                HulkappWishlist._bulkUpdate();
                HulkappWishlist._wishlistFloatingButton();
            }
        }

        if(deactivatedStore == true){
            allHulkWishlistButtons.forEach(function(ele){
                ele.remove();
            });
            document.querySelectorAll('[data-hulksaveforlater]').forEach(function(ele){
                ele.remove();
            });
            return;
        }
        if(customerID == undefined || customerID == null || customerID.length <= 0){
            customerStatus = 'Guest';
        }

        if(customerStatus == 'Customer'){
            HulkappWishlist._deleteHulkWishlist();
        }

        if(window.hulkappsWishlist.productJSON && window.hulkappsWishlist.productJSON.tags) {
            var excludeEnabled = window.hulkappsWishlist.generalSettings.is_exclude_enabled ? window.hulkappsWishlist.generalSettings.is_exclude_enabled : false;
            var excludedProductTags = (window.hulkappsWishlist.generalSettings.exclude_product_tags) ? window.hulkappsWishlist.generalSettings.exclude_product_tags : [];
            if(excludedProductTags !== undefined) {
                var isExcluded =  excludedProductTags.some(value => window.hulkappsWishlist.productJSON.tags.includes(value));
                if(excludeEnabled && isExcluded) {
                    document.body.classList.add('hide-hulk-wishlist');
                }
            }
        }
        if(headerIconDesign === 'wishlist_drawer' && headerIconPosition !== 'auto_header_icon'){
            if(document.querySelector('[data-viewMoreDrawer]') != undefined || document.querySelector('[data-viewMoreDrawer]') != null) {
                document.querySelector('[data-viewMoreDrawer]').setAttribute('href', proxyURL);
            }
            let wlDrawer = document.querySelector('.hulk-wishlist-drawer');
            if(proxyURL != window.location.pathname) {
                HulkappWishlist._openMyWishlistDrawer(wlDrawer);
            }
        }
        let hulkHeaderIcon = document.querySelector(".hulk-header-icon");
        if(headerIconPosition === 'auto_header_icon' && headerType === 'header_menu') {
            if(hulkHeaderIcon) {
                hulkHeaderIcon.remove();
            }
            HulkappWishlist._setHeaderIcon();
        }
        if(headerType === 'main_menu') {
            if(hulkHeaderIcon) {
                hulkHeaderIcon.remove();
            }
        }
        saveForLaterType = (WishlistSettings.style.save_for_later_type) ? WishlistSettings.style.save_for_later_type : 'individual_button';
        saveForLaterPosition = (WishlistSettings.style.individual_button_position) ? WishlistSettings.style.individual_button_position : 'individual_button_manual';
        saveAllForLaterPosition = (WishlistSettings.style.global_button_position) ? WishlistSettings.style.global_button_position : 'global_button_manual';

        if(WishlistSettings.general.google_conversion_tracking_code != ""){
            let googleTagScript = document.createElement("script");
            googleTagScript.setAttribute('src','https://www.googletagmanager.com/gtag/js?id='+WishlistSettings.general.google_conversion_tracking_code);
            googleTagScript.async = true;
            let googleTracking = document.createElement("script");
            googleTracking.innerHTML = "window.dataLayer = window.dataLayer || [];\n function gtag(){dataLayer.push(arguments);} \n";
            googleTracking.innerHTML += "gtag('js', new Date()); \n gtag('config', '"+WishlistSettings.general.google_conversion_tracking_code+"');";
            document.getElementsByTagName('head')[0].appendChild(googleTagScript);
            document.getElementsByTagName('head')[0].appendChild(googleTracking);
        }

        HulkappWishlist._manageGuestCookie();
        HulkappWishlist._getShopSettings();
        HulkappWishlist._removeMyWishlist();
        HulkappWishlist._addProductToCart();
    },

    _removeMyWishlist: function(){
        document.addEventListener('click', function(event){
            if(event.target && event.target.hasAttribute('data-hulkdeleteproduct') == true){
                event.preventDefault();
                event.stopImmediatePropagation();
                const currentParent = event.target.closest('.wishlist-card');
                let product_id = [currentParent.getAttribute('data-proid')];
                let variant_id = [currentParent.getAttribute('data-varid')];
                hulkDeleteWishlistItemsPrompt.classList.add('open');
                document.querySelector('[data-hulkappsdeleteitemsprompt] h4').innerHTML = (WishlistSettings.language.title.delete_product_text) ? WishlistSettings.language.title.delete_product_text : 'Are you sure you want to delete this product?';
                hulkDeleteWishlistItems.onclick = function() {
                    hulkDeleteWishlistItemsPrompt.classList.remove('open');
                    if(customerStatus == 'Guest'){
                        HulkappWishlist._removeFromGuestWishlist(product_id, variant_id, 'single');
                    }else{
                        HulkappWishlist._removeFromCustomerWishlist(product_id, variant_id, 'single');
                    }
                }
            }
        });
    },
   
    _addProductToCart: function(){
        document.addEventListener('click', function(event){
            if(event.target && event.target.hasAttribute('data-addprotocart') == true){
                event.preventDefault();
                const currentParent = event.target.closest('.wishlist-card');
                const proID = [currentParent.getAttribute('data-proid')];
                const varID = [currentParent.getAttribute('data-varid')];
                HulkappWishlist._moveProductToCart(proID, varID, 'single');
                /*hulkMoveWishlistItemsPrompt.classList.add('open');
                document.querySelector('[data-hulkappsmoveitemsprompt] h4').innerHTML = (WishlistSettings.language.title.move_wishlist_text) ? WishlistSettings.language.title.move_wishlist_text : 'Are you sure you want to move this item to your cart?';
                const buttonEle = event.target;
                const currentParent = buttonEle.closest('.wishlist-card');
                document.addEventListener('click', function(event){
                    if(event.target && event.target.hasAttribute('data-hulkappsMoveItemsOk') == true) {
                        hulkMoveWishlistItemsPrompt.classList.remove('open');
                        const proID = [currentParent.getAttribute('data-proid')];
                        const varID = [currentParent.getAttribute('data-varid')];
                        HulkappWishlist._moveProductToCart(proID, varID, 'single');
                    }
                });
                var siteMoveOverLay = document.querySelector('[data-hulkappsMoveItemsPrompt]');
                if(siteMoveOverLay != null) {
                    siteMoveOverLay.addEventListener('click', function(e) {
                        var closer = e.target.closest('.wishlist-modal');
                        if(closer == null) {
                            document.querySelector('[data-hulkappsMoveItemsCancel]')?.click();
                        }
                    })
                }
                document.addEventListener('click', function(event) {
                    if (event.target && event.target.hasAttribute('data-hulkappsMoveItemsCancel') == true) {
                        hulkMoveWishlistItemsPrompt.classList.remove('open');
                    }
                });*/
            }
        });
    },

    _checkForProductStatus: function(wishlistBtns, btnType){
        if(typeof(wishlistBtns) == 'undefined' || wishlistBtns == null || wishlistBtns.length <=0 ){
            return false;
        }

        let productsListing = [];
        wishlistBtns.forEach(function(element, index){
            productsListing.push({
                product_id: element.getAttribute('data-proid'),
                variant_id: element.getAttribute('data-varid')
            })
        });

        let requestData = {
            shop: hulkShopDomain,
            ids: productsListing,
        };

        if(customerStatus == 'Guest'){
            requestData.uuid = hulkUserUUID;
            let shopURL = window.hulkappsWishlist.baseURL + '/wishlist/product_status/guest';
            HulkappWishlist._XMLHttpRequest('POST', shopURL, requestData, null, null,function(status, response){
                let finalResponse = JSON.parse(response);
                if(status == 200){
                    if(WishlistSettings.general.is_guest_enabled == true){
                        HulkappWishlist._updateBtnonStatusCheck(wishlistBtns, finalResponse, 'Guest');
                    }else{
                        HulkappWishlist._updateBtnonStatusCheck(wishlistBtns, finalResponse, 'Guest_Disabled');
                    }
                }else{
                    let msg = 'Something went wrong. Please try again later !';
                    if(finalResponse.message){ msg = finalResponse.message; }
                    HulkappWishlist._messageUpdate(msg);
                }
            });
        }else{
            requestData.customer_id = customerID;
            let shopURL = window.hulkappsWishlist.baseURL + '/wishlist/product_status';
            HulkappWishlist._XMLHttpRequest('POST', shopURL, requestData, hulkShopDomain, customerID,function(status, response){
                let finalResponse = JSON.parse(response);
                if(status == 200){
                    wishlistProductsData = finalResponse;
                    HulkappWishlist._updateBtnonStatusCheck(wishlistBtns, finalResponse, 'Customer');
                }else{
                    let msg = 'Something went wrong. Please try again later !';
                    if(finalResponse.message){ msg = finalResponse.message; }
                    HulkappWishlist._messageUpdate(msg);
                }
            });
        }

        if(wishlistTotal && btnType != 'variantChange'){
            HulkappWishlist._updateWishlistTotal();
        }
    },

    _updateBtnonStatusCheck: function(productsListing, finalResponse, customerStatus){
        productsListing.forEach(function(wishlistItem){
            let varId = parseInt(wishlistItem.getAttribute('data-varid'));
            let status, btnClass, wishlistCount, btnText, customIcon, iconStyle, collectionIconStyle;
            let foundProduct = finalResponse.find(function(product){
                /*if(product.product_tags) {
                    if(excludedProductTags !== undefined) {
                        var isExcluded =  excludedProductTags.some(value => product.product_tags.includes(value));
                        if(product && excludeEnabled && isExcluded) {
                            var wishlistIcon = document.querySelector('.wishlist-btn');
                            wishlistIcon.classList.add('hide-hulk-product-wishlist');
                            wishlistIcon.style.display = null;
                        }
                    }
                }*/
                let identifier = parseInt(product.variant_id);
                if(identifier === varId){ return product; }
            });
            if(foundProduct.product_tags) {
                if(excludedProductTags !== undefined) {
                    var isExcluded =  excludedProductTags.some(value => foundProduct.product_tags.includes(value));
                    if(foundProduct && excludeEnabled && isExcluded) {
                        var wishlistIcon = document.querySelector('.wishlist-btn[data-proid="'+foundProduct.product_id+'"]');
                        setTimeout(function(){
                            wishlistIcon.classList.add('hide-hulk-product-wishlist');
                            wishlistIcon.style.display = null;
                        }, 200);
                    }
                }
            }

            if(foundProduct != null && (customerStatus == 'Guest' && foundProduct.is_exist == true) || (customerStatus == 'Customer' && foundProduct.wishlist_ids && foundProduct.wishlist_ids.length >0)){
                status = true;
                btnClass = 'icon-wishlist-heart '+wishlistBtnStyle+' wishlist-btn heart-wishlist-animation';
                btnText = WishlistSettings.language.success_button_text;
                wishlistCount = foundProduct.wishlist_count;
                customIcon = WishlistSettings.style.filled_set_custom_icon;
                iconStyle = fillIconStyle;
                collectionIconStyle = fillCollectionIconStyle;
            }else{
                status = false;
                btnClass = 'icon-wishlist-heart-empty '+wishlistBtnStyle+' wishlist-btn heart-wishlist-animation';
                btnText = WishlistSettings.language.button_text;
                if(foundProduct && foundProduct.wishlist_count > 0){
                    wishlistCount = foundProduct.wishlist_count;
                }else{
                    wishlistCount = 0;
                }
                customIcon = WishlistSettings.style.empty_set_custom_icon;
                iconStyle = emptyIconStyle;
                collectionIconStyle = emptyCollectionIconStyle;
            }
            let compactWishlistCount = '';
          //HulkappWishlist._compactNumbers(wishlistCount);
            let productPageWishlistCount = 0;
            let collectionPageWishlistCount = 0;
            if(WishlistSettings.general.product_compact_numbers) {
                //productPageWishlistCount = compactWishlistCount;
            } else {
                productPageWishlistCount = wishlistCount;
            }
            if(WishlistSettings.general.collection_compact_numbers) {
              //  collectionPageWishlistCount = compactWishlistCount;
            } else {
                collectionPageWishlistCount = wishlistCount;
            }

            if(window.hulkappsWishlist.hasAppBlockSupport !== '1') {
                wishlistItem.setAttribute('class', btnClass);
            }

            if(wishlistItem.querySelector('.hulk_wl_icon') != undefined || wishlistItem.querySelector('.hulk_wl_icon') != null) {
                wishlistItem.querySelector('.hulk_wl_icon').setAttribute('style', iconStyle);
            }

            if(wishlistItem.querySelector('.collection-icon') != undefined || wishlistItem.querySelector('.collection-icon') != null) {
                wishlistItem.querySelector('.collection-icon').setAttribute('style', collectionIconStyle);
            }

            if(wishlistItem.getElementsByClassName('hulk-wishlist-custom-icon')[0] !== undefined) {
                wishlistItem.getElementsByClassName('hulk-wishlist-custom-icon')[0].setAttribute('src', customIcon);
            }

            //wishlistItem.setAttribute('hulk-wishlist-custom-icon', customIcon);
            wishlistItem.setAttribute('data-added', status);
            if(wishlistItem.querySelector('span')){
                wishlistItem.querySelector('span').innerHTML = btnText;
            }
            if(wishlistItem.querySelector('.count')){
                if(WishlistSettings.general.public_wishlist_count === 'show') {
                    wishlistItem.querySelector('.count').style.display = 'none';
                }
                if(wishlistItem.querySelector('.hulkapps-collection-count') !== null) {
                    if(collectionCountLayout === 'top_count') {
                        wishlistItem.querySelector('.hulkapps-collection-count').innerHTML = collectionPageWishlistCount;
                    } else {
                        wishlistItem.querySelector('.hulkapps-collection-count').innerHTML = '(' + collectionPageWishlistCount + ')';
                    }

                }
                if(wishlistItem.querySelector('.hulkapps-public-count') !== null) {
                    if(buttonLayout === 'multi_color_button' && (WishlistSettings.style.button_style === 'style_2' || WishlistSettings.style.button_style === 'style_4')) {
                        wishlistItem.querySelector('.hulkapps-public-count').innerHTML = productPageWishlistCount;
                    } else {
                        wishlistItem.querySelector('.hulkapps-public-count').innerHTML = '(' + productPageWishlistCount + ')';
                    }
                }
            }

            if(WishlistSettings.general.product_page_tooltip && WishlistSettings.general.public_wishlist_count === 'show') {
                let tooltipTitle = WishlistSettings.general.tooltip_message + ' '+productPageWishlistCount+' ' + WishlistSettings.general.tooltip_time_message;
                wishlistItem.setAttribute('title', tooltipTitle);
            }
        });
    },
    _updateuserWishlists: function(){
        if(!wishlistsData || wishlistsData == null || wishlistsData == undefined){
            return;
        }

        let wishlistHTML = '';
        if(typeof(wishlistsData) === "string"){wishlistsData = JSON.parse(wishlistsData)}
        wishlistsData.forEach(function(element){
            wishlistHTML += ' <li data-id="'+element.id+'" data-userhulkwishlist>';
            wishlistHTML += '<div class="input-group my-wishlist-input-group"><input type="checkbox" data-wishlistItem value="'+element.id+'" id="wishlist-'+element.id+'"><label for="wishlist-'+element.id+'" class="wishlist-checkbox"><span></span>'+element.name+'</label>';
            if(element.is_default == false) {
                wishlistHTML += '<div class="content_remove" data-confirmDeleteWishlist="" style="float: right;"><a href="#" class="icon-wishlist-bin hulkThemeColor delete-wishlist"></a></div>';
            }
            wishlistHTML += '</div>';
            wishlistHTML += '</li>';
        });
        if(document.querySelectorAll('[data-userWishlists]') != null && document.querySelectorAll('[data-userWishlists]') != undefined){
            document.querySelectorAll('[data-userWishlists]')[0].innerHTML = wishlistHTML;
        }
        if(document.querySelectorAll('[data-openCreateSection]') != null && document.querySelectorAll('[data-openCreateSection]') != undefined){
            document.querySelectorAll('[data-openCreateSection]')[0].style.display  = 'block';
        }
        if(document.querySelectorAll('[data-addNewWishlist]') != null && document.querySelectorAll('[data-addNewWishlist]') != undefined){
            document.querySelectorAll('[data-addNewWishlist]')[0].style.display  = 'none';
        }
    },
    /*********************************    To get App settings for frontend Population    ********************************/
    _getShopSettings: function(){
        wishlistsData = sessionStorage.getItem('wishlistsData') || [];
        // var settingsData = sessionStorage.getItem('hulkapps_wishlist_settings');//removed bcz create issue for collection page wishlist added 2 times
        // if(settingsData) {
        //     HulkappWishlist.(settingsData);
        // }

        HulkappWishlist._allocateStyles(WishlistSettings);

        let ShopURL = window.hulkappsWishlist.baseURL + '/shop/settings?shop='+hulkShopDomain;
        

        // To move The Guest WishlistData from Local Storage to Server
        guestWishlistData = localStorage.getItem('HulkApps-wishlist-guestData') || null;
        if(guestWishlistData && guestWishlistData != null && guestWishlistData != undefined){
            guestWishlistData = JSON.parse(guestWishlistData);
            if(customerStatus != 'Customer' && guestWishlistData.length > 0){
                HulkappWishlist._addFromGuestTodata(guestWishlistData);
            }
        }
        let pageHeading = document.querySelector('.hulk__wishlist-wrap [data-wishlisttitle]');
        let loginMsg = document.querySelector('[data-HulkLoginMsg] h3');
        let position = WishlistSettings.general.title_position;
        let headerFontSize = WishlistSettings.general.header_font_size;
        let loginMessageFontSize = WishlistSettings.general.login_message_font_size;
        if (pageHeading && typeof position != 'undefined' && position) {
            pageHeading.style.textAlign = position;
        }
        if (pageHeading && typeof headerFontSize != 'undefined' && headerFontSize) {
            pageHeading.style.fontSize = headerFontSize+'px';
        }
        if (loginMsg && typeof loginMessageFontSize != 'undefined' && loginMessageFontSize) {
            loginMsg.style.fontSize = loginMessageFontSize+'px';
        }
        let isCustomTitle = (WishlistSettings.general.is_my_wishlist_custom_title) ? WishlistSettings.general.is_my_wishlist_custom_title : false;
        let customTitle = (WishlistSettings.general.my_wishlist_custom_title) ? WishlistSettings.general.my_wishlist_custom_title : 'Your Wishlist';
        if(isCustomTitle) {
            document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML = customTitle;
        } else {
            document.querySelectorAll('[data-wishlistTitle]')[0].innerHTML = WishlistSettings.language.title.guest_wishlist_title;
        }
    },

    _deleteHulkWishlist: function(){
        document.addEventListener('click', function(event){
            if(event.target && event.target.hasAttribute('data-confirmDeleteWishlist') == true || event.target.classList.contains('delete-wishlist') == true ){
                event.preventDefault();
                let currentTarget = event.target;
                const wishlistID = currentTarget.closest('[data-userhulkwishlist]').getAttribute('data-id');
                globalHulkDeleteWishlistPrompt.setAttribute('data-wishlist', wishlistID)
                globalHulkDeleteWishlistPrompt.classList.add('open');
            }
        });

        document.addEventListener('click', function(event){
            if(event.target && event.target.hasAttribute('data-deletehulkwishlist') == true){
                event.preventDefault();
                let currentTarget = event.target;
                const wishlistID = currentTarget.closest('[data-hulkappsdeleteprompt]').getAttribute('data-wishlist');
                const data = {
                    customer_id: customerID,
                    shop: hulkShopDomain,
                    wishlist_id: wishlistID,
                };

                if(wishlistID == null || wishlistID == undefined){
                    globalHulkDeleteWishlistPrompt.classList.remove('open');
                    globalHulkDeleteWishlistPrompt.removeAttribute('data-wishlist');
                    let msg = 'Please select wishlist to delete.';
                    HulkappWishlist._messageUpdate(msg);
                    return;
                }

                let triggerDefault = false;
                if(globalSelectedWishlistID == wishlistID){
                    triggerDefault = true;
                }
                currentTarget.classList.add('disabled');
                HulkappWishlist._XMLHttpRequest('POST', window.hulkappsWishlist.baseURL + '/wishlist/delete', data, null, null,function(status, response){
                    let finalResponse = JSON.parse(response);
                    if(status == 200){
                        //document.querySelectorAll('[data-hulkappsDeletePrompt]')[0].style.display = 'none';
                        //hulkAddNewWishlistBtn.style.display = 'none';
                        document.querySelectorAll('[data-hulkappsDeletePrompt]')[0].classList.remove('open');
                        document.querySelectorAll('[data-hulkappsDeletePrompt]')[0].removeAttribute('data-wishlist');
                        document.querySelector('[data-newWishlist]').value = '';
                        currentTarget.classList.remove('disabled');
                        if(triggerDefault == true && document.querySelectorAll('[data-userhulkwishlist][data-id="'+DefaultWishlistID+'"]')){
                            document.querySelectorAll('[data-userhulkwishlist][data-id="'+DefaultWishlistID+'"]')[0].querySelector('[data-hulkwishlistview]').click();
                        }
                       // HulkappWishlist._getUserWishlist();
                        let msg = 'Wishlist has been deleted!';
                        if(finalResponse.message){ msg = finalResponse.message; }
                        HulkappWishlist._messageUpdate(msg);
                        if(wishlistTotal){
                            HulkappWishlist._updateWishlistTotal();
                        }
                    }else{
                        let msg = 'Something went wrong. Please try again later !';
                        if(finalResponse.message){ msg = finalResponse.message; }
                        HulkappWishlist._messageUpdate(msg);
                        document.querySelectorAll('[data-data-hulkappsDeletePrompt]')[0].classList.remove('open');
                        document.querySelectorAll('[data-data-hulkappsDeletePrompt]')[0].removeAttribute('data-wishlist');
                    }
                });
            }
        });
    },
  
    _getCookie: function(cname){
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    _allocateStyles: function(response) {
        wishlistsData = sessionStorage.getItem('wishlistsData') || [];
        WishlistSettings = response;
        appStatus = WishlistSettings.general.frontend_enabled;

        if(appStatus == false){
            allHulkWishlistButtons.forEach(function(ele){
                ele.remove();
            });
            document.querySelectorAll('[data-hulksaveforlater]').forEach(function(ele){
                ele.remove();
            });
            return;
        }

        let globalStyle = WishlistSettings.general.css_style;
        if(WishlistSettings.general && globalStyle && globalStyle != ''){
            var hulkGlobalStyle = document.createElement('style');
            hulkGlobalStyle.type = 'text/css';
            hulkGlobalStyle.id = 'hulk--global-stylesheet';
            if (hulkGlobalStyle.styleSheet){
                hulkGlobalStyle.styleSheet.cssText = globalStyle;
            }
            else{
                hulkGlobalStyle.appendChild(document.createTextNode(globalStyle));
            }
            document.getElementsByTagName("head")[0].appendChild(hulkGlobalStyle);
        }

        let headerIcon = document.getElementsByClassName('hulk-header-icon')[0];
        if(headerIcon !== undefined && headerIcon !== null) {
            let iconElem = headerIcon.firstElementChild;
            iconElem.style.color =  (WishlistSettings.style.header_icon_color) ? WishlistSettings.style.header_icon_color : '#000';
            iconElem.style.fontSize =  (WishlistSettings.style.header_icon_size) ? WishlistSettings.style.header_icon_size + 'px' : '16px';
            iconElem.style.fontWeight = (WishlistSettings.style.header_icon_weight) ? WishlistSettings.style.header_icon_weight : 500;
        }
        let headerCountEle = document.getElementsByClassName('header-count')[0];
        if(headerCountEle !== undefined && headerCountEle !== null) {
            headerCountEle.style.backgroundColor = (WishlistSettings.general.header_count_background_color) ? WishlistSettings.general.header_count_background_color : WishlistSettings.style.theme_color;
            headerCountEle.style.color = (WishlistSettings.general.header_count_color) ? WishlistSettings.general.header_count_color : '#fff';
        }

        if(window.hulkappsWishlist.hasAppBlockSupport === '1') {
            var myEm = document.querySelector('.icon-wishlist-heart-empty.wishlist-btn:not([data-gridhulklist])');
            if(myEm != undefined && myEm != null) {
                myEm.classList.add('hulkapps-wishlist-btn-enabled');
            }
            if(WishlistSettings.style.button_icon_type === 'custom_icon') {
                var animationElm = document.querySelector('.heart-hulk-animation');
                if(animationElm) {
                    var customIconElm = document.createElement('div');
                    customIconElm.classList.add('wishlist_btn_icon');
                    customIconElm.classList.add('hulk_wl_icon');
                    customIconElm.style.display = 'initial';
                    customIconElm.innerHTML = '<img data-v-4e6b1d8c="" src="'+WishlistSettings.style.empty_set_custom_icon+'" class="hulk-wishlist-custom-icon" width="18px" height="18px" style="line-height: 1;cursor: pointer;margin-right: 5px;user-select: none;vertical-align: middle;margin-top: -2px;">';
                    animationElm.parentNode.replaceChild(customIconElm, animationElm);
                }
            }
        }

        if(WishlistSettings && WishlistSettings.style.button_style === 'style_1' && window.hulkappsWishlist.hasAppBlockSupport !== '1'){
            WishlistSettings.language.button_text = '';
            WishlistSettings.language.success_button_text = '';
        }

        if(WishlistSettings && WishlistSettings.style.position != 'custom' && window.hulkappsWishlist.hasAppBlockSupport !== '1'){
            HulkappWishlist._addWishlistButton();
        }
        if(WishlistSettings && WishlistSettings.style.position == 'custom' && window.hulkappsWishlist.hasAppBlockSupport !== '1'){
            HulkappWishlist._manageWishlistBtnSettings();
        }

        HulkappWishlist._updateWishlistButton();

        if(customerStatus == 'Customer' && WishlistSettings.general.is_guest_enabled == true && hulkUserUUID != null){
            HulkappWishlist._addToWishlistFromGuestList();
        }

        excludeEnabled = window.hulkappsWishlist.generalSettings.is_exclude_enabled ? window.hulkappsWishlist.generalSettings.is_exclude_enabled : false;
        excludedProductTags = window.hulkappsWishlist.generalSettings.exclude_product_tags;

        saveForLaterColor = (WishlistSettings.style.individual_save_items_text_color) ? WishlistSettings.style.individual_save_items_text_color : '#000000';
        saveForLaterHoverColor = (WishlistSettings.style.individual_save_items_text_hover_color) ? WishlistSettings.style.individual_save_items_text_hover_color : '#000000';
        saveForLaterFontSize = (WishlistSettings.style.individual_save_items_font_size) ? WishlistSettings.style.individual_save_items_font_size + 'px' : '16px';
        saveForLaterFontWeight = (WishlistSettings.style.individual_save_items_font_thickness) ? WishlistSettings.style.individual_save_items_font_thickness : 500;

        saveAllForLaterBtnText = (WishlistSettings.language.button.save_all_for_later) ? WishlistSettings.language.button.save_all_for_later : 'Save all for later';
        saveAllForLaterBtnBackgroundColor = (WishlistSettings.style.global_button_bg_color) ? WishlistSettings.style.global_button_bg_color : '#5c6ac4';
        saveAllForLaterBorderColor = (WishlistSettings.style.global_button_border_color) ? WishlistSettings.style.global_button_border_color : '#5c6ac4';
        saveAllForLaterBtnBorder = (WishlistSettings.style.global_button_border_width) ? WishlistSettings.style.global_button_border_width : 0;
        saveAllForLaterBtnBorderRadius = (WishlistSettings.style.global_button_border_radius) ? WishlistSettings.style.global_button_border_radius : 0;
        saveAllForLaterBtnColor = (WishlistSettings.style.global_button_text_color) ? WishlistSettings.style.global_button_text_color : '#ffffff';
        saveAllForLaterFontSize = (WishlistSettings.style.global_button_font_size) ? WishlistSettings.style.global_button_font_size : 16;
        saveAllForLaterBtnFontWeight = (WishlistSettings.style.global_button_font_thickness) ? WishlistSettings.style.global_button_font_thickness : 500;
        saveAllForLaterBtnVerticalSpace = (WishlistSettings.style.global_button_vertical_space) ? WishlistSettings.style.global_button_vertical_space : 7;
        saveAllForLaterBtnHorizontalSpace = (WishlistSettings.style.global_button_horizontal_space) ? WishlistSettings.style.global_button_horizontal_space : 10;
        saveAllForLaterBtnBackgroundHoverColor = (WishlistSettings.style.global_button_bg_hover_color) ? WishlistSettings.style.global_button_bg_hover_color : '#5c6ac4';
        saveAllForLaterBtnHoverColor = (WishlistSettings.style.global_button_text_hover_color) ? WishlistSettings.style.global_button_text_hover_color : '#ffffff';

        showQuantitySection = (WishlistSettings.general.show_quantity != undefined) ? WishlistSettings.general.show_quantity : false;

        let saveForLaterStatus = typeof WishlistSettings.general.save_for_later_status != 'undefined' ? WishlistSettings.general.save_for_later_status : true;
        let hulkWishlistSaveButton = document.querySelectorAll('[data-hulkSaveForLater]');
        let hulkSaveAllForLaterButton = document.querySelector('[data-hulksaveforlaterallitems]');
        if(!saveForLaterStatus && (saveForLaterType != 'global_button' && saveForLaterPosition === 'individual_button_automatic')) {
            if (typeof (hulkWishlistSaveButton) != 'undefined' && hulkWishlistSaveButton != null && hulkWishlistSaveButton.length > 0) {
                hulkWishlistSaveButton.forEach(function (button) {
                    button.remove();
                });
            }
        }
        if(!saveForLaterStatus && (saveForLaterType != 'individual_button' && saveAllForLaterPosition === 'global_button_automatic')) {
            if (typeof (hulkSaveAllForLaterButton) != 'undefined' && hulkSaveAllForLaterButton != null) {
                hulkSaveAllForLaterButton.remove();
            }
        }

        if(saveForLaterStatus) {
            if(saveForLaterType != 'global_button' && saveForLaterPosition === 'individual_button_automatic') {
                let saveForLaterSelector = (WishlistSettings.style.save_for_later_selector) ? WishlistSettings.style.save_for_later_selector : ".list-view-item__title";
                let cartPageElement = document.querySelectorAll(saveForLaterSelector);

                if(cartPageElement != undefined && cartPageElement != null) {
                    new Promise((resolve, reject) => {
                        let response = HulkappWishlist._getCartItems();
                        resolve(response);
                    }).then(function(response) {
                        new Promise((resolve, reject) => {
                            resolve(response.json());
                        }).then((output) => {
                            output.items.forEach(function(item, index){
                                let selectedEle = document.querySelectorAll(saveForLaterSelector)[index];
                                if(selectedEle != undefined && selectedEle != null) {
                                let saveForLaterElem = '<a href="#" style="color: '+saveForLaterColor+'; font-size: '+saveForLaterFontSize+'; font-weight: '+saveForLaterFontWeight+';" class="addtoWishlist" data-hulksaveforlater="" data-product-id="'+item.product_id+'" data-variant-id="'+item.variant_id+'" data-line="'+(index+1)+'">'+WishlistSettings.language.button.save_for_later+'</a>';
                                    selectedEle.insertAdjacentHTML("afterend", saveForLaterElem);
                                }
                            });
                        });
                    }).catch((error) => {
                        throw error;
                    });
                }
            }

        setTimeout(function() {
                hulkWishlistSaveButton = document.querySelectorAll('[data-hulkSaveForLater]');
            if(hulkWishlistSaveButton != undefined && hulkWishlistSaveButton != null && hulkWishlistSaveButton.length > 0) {
                    let productIds = [];
                hulkWishlistSaveButton.forEach(function(item) {
                        productIds.push(item.getAttribute('data-product-id'));
                    item.addEventListener('mouseover', function(){
                            item.style.color = saveForLaterHoverColor;
                        });
                    item.addEventListener('mouseout', function(){
                            item.style.color = saveForLaterColor;
                        });
                    });
                let shopURL = window.hulkappsWishlist.baseURL + '/product_tags?shop='+hulkShopDomain+'&product_ids='+productIds;
                HulkappWishlist._XMLHttpRequest('GET', shopURL, '', null, null,function(status, response){
                        let finalResponse = JSON.parse(response);
                    if(status == 200){
                        let productTags  = finalResponse.product_tags;
                        for(productTag in productTags) {
                            if(productTags[productTag].length > 0 && excludedProductTags !== undefined){
                                var isExcluded =  excludedProductTags.some(value => productTags[productTag].includes(value));
                                if(excludeEnabled && isExcluded) {
                                    document.querySelector('[data-product-id="'+productTag+'"]').style.display = 'none';
                                    }
                                }
                            }
                        }
                    });
                }
            }, 400);
           // HulkappWishlist._saveForLater();

            if (saveForLaterType != 'individual_button' && saveAllForLaterPosition === 'global_button_automatic') {
                let saveAllForLaterSelector = (WishlistSettings.style.save_all_for_later_selector) ? WishlistSettings.style.save_all_for_later_selector : "[name=\'checkout\']";
                let cartPageElement = document.querySelector(saveAllForLaterSelector);
            if(cartPageElement != undefined && cartPageElement != null) {
                let saveForLaterElem = '<a href="#" class="manual" style="padding: '+saveAllForLaterBtnVerticalSpace+'px '+saveAllForLaterBtnHorizontalSpace+'px; font-size: '+saveAllForLaterFontSize+'px; font-weight: '+saveAllForLaterBtnFontWeight+'; background-color: '+saveAllForLaterBtnBackgroundColor+'; color: '+saveAllForLaterBtnColor+'; border: '+saveAllForLaterBtnBorder+'px solid '+saveAllForLaterBorderColor+'; border-radius: '+saveAllForLaterBtnBorderRadius+'px" class="addtoWishlist" data-hulkSaveForLaterallItems>'+saveAllForLaterBtnText+'</a>';
                    cartPageElement.insertAdjacentHTML("beforebegin", saveForLaterElem);
                }
            }
            hulkSaveAllForLaterButton = document.querySelector('[data-hulksaveforlaterallitems]');
        if(hulkSaveAllForLaterButton != undefined && hulkSaveAllForLaterButton != null) {
            hulkSaveAllForLaterButton.addEventListener('mouseover', function(){
                    hulkSaveAllForLaterButton.style.backgroundColor = saveAllForLaterBtnBackgroundHoverColor;
                    hulkSaveAllForLaterButton.style.color = saveAllForLaterBtnHoverColor;
                });
            hulkSaveAllForLaterButton.addEventListener('mouseout', function(){
                    hulkSaveAllForLaterButton.style.backgroundColor = saveAllForLaterBtnBackgroundColor;
                    hulkSaveAllForLaterButton.style.color = saveAllForLaterBtnColor;
                });
            }
            //HulkappWishlist._saveAllForLater();
        }

        const hulkWishlistListing =  allHulkWishlistButtons[0];
        if (typeof(hulkWishlistListing) != 'undefined' && hulkWishlistListing != null){
            allHulkWishlistButtons.forEach(function(ele){
                if(window.hulkappsWishlist.hasAppBlockSupport !== '1' && WishlistSettings.style.button_style != 1) {
                    ele.querySelector('span').innerHTML = WishlistSettings.language.button_text;
                }
            });
            HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
        }else{
            HulkappWishlist._updateWishlistTotal();
        }

        if(customerID != '' && customerID != null && customerID != undefined){
            if(!wishlistsData || wishlistsData === undefined || wishlistsData === 'undefined' || wishlistsData === null || wishlistsData === 'null') {
                wishlistsData = [];
            }else if(wishlistsData.length > 0){
                wishlistsData = JSON.parse(wishlistsData);
            }
            if(proxyURL != window.location.pathname) {
                //HulkappWishlist._searchWishlist();
            }
            //HulkappWishlist._getUserWishlist();
            HulkappWishlist._updateuserWishlists();
        }

        //HulkappWishlist._manageWishlistButtonAction();
        //HulkappWishlist._someBaseFunction();
        //HulkappWishlist._createNewWishlist();
        //HulkappWishlist._updateButtonStateonVariantChange();
        //HulkappWishlist._updateWishlistText();
    },

    _updateWishlistButton: function(){
        const btnSettings = WishlistSettings.style;
        wishlistBtnStyle = btnSettings.button_style;
        let btnStyle, regularBtns, regularDenyBtns;
        regularBtns = 'background-color: '+WishlistSettings.style.theme_color+'; border: 1px solid '+WishlistSettings.style.theme_color+'; color: white;';
        regularDenyBtns = 'background-color: white;border: 1px solid '+WishlistSettings.style.theme_color+'; color:'+WishlistSettings.style.theme_color;

        if(WishlistSettings && WishlistSettings.style.button_style == 'style_1' || WishlistSettings.style.button_style == 'style_3' || WishlistSettings.style.button_style == 'style_5'){
            btnStyle = 'color: '+WishlistSettings.style.theme_color+';';
        }else{
            btnStyle = 'border-radius: '+btnSettings.button_border_radius+'px; font-size: '+btnSettings.button_font_size+'px; font-weight: '+btnSettings.button_font_weight+';';
        }

        const wishlistBtn = document.querySelectorAll('[data-wishlist]');
        for (var i = 0; i < wishlistBtn.length; i++) {
            if (wishlistBtn[i].hasAttribute('data-gridhulklist') == true) {
                let countEle = wishlistBtn[i].querySelector('.count');
                if(countEle != undefined || countEle != null) {

                    if(!WishlistSettings.style.custom_wishlist_icon) {
                        collectionCountLayout = 'beside_count';
                    }
                    countEle.setAttribute('data-layout', collectionCountLayout);
                    if(collectionCountLayout === 'top_count') {
                        countEle.style.backgroundColor = (WishlistSettings.style.collection_count_background_color) ? WishlistSettings.style.collection_count_background_color : WishlistSettings.style.theme_color;
                        countEle.style.color = (WishlistSettings.style.collection_count_color) ? WishlistSettings.style.collection_count_color : '#fff';
                        if(collectionIconSize > 20) {
                            countEle.style.right = '-0.3rem';
                            countEle.style.bottom = '1.5rem';
                            countEle.style.width = '1.8em';
                            countEle.style.height = '1.8em';
                        }
                    }
                }
                let btn = wishlistBtn[i];

                if(WishlistSettings.general.collection_wishlist_count === 'show'){
                    wishlistBtn[i].querySelector('.count').classList.add('hulkapps-collection-count');
                }
                if(wishlistBtn[i].querySelector('.heart-hulk-animation') != undefined) {
                    let collectionIcon = wishlistBtn[i].querySelector('.heart-hulk-animation');
                    collectionIcon.classList.add('collection-icon');

                    if(isCustomizeCollectionIcon) {
                        collectionIcon.setAttribute('data-icon', collectionIconType);

                        wishlistBtn[i].addEventListener('mouseover', function (event) {
                            collectionIcon.style.color = collectionIconHoverColor;
                        });

                        wishlistBtn[i].addEventListener('mouseout', function (event) {
                            collectionIcon.style.color = (btn.getAttribute('data-added') == 'true') ?  selectedCollectionIconFillColor : collectionIconFillColor;
                        });
                    }
                }

                if(WishlistSettings.style.button_icon_type === 'custom_icon') {
                    wishlistBtn[i].getElementsByClassName('wishlist_btn_icon')[0].innerHTML = '<img src="'+WishlistSettings.style.empty_set_custom_icon+'" class="hulk-wishlist-custom-icon" width="18px" height="18px" style="line-height: 1;cursor: pointer;margin-right: 5px;user-select: none;vertical-align: middle;margin-top: -2px;">';
                }
                wishlistBtn[i].classList.add('style_1');
                wishlistBtn[i].setAttribute("style", 'color: ' + WishlistSettings.style.theme_color + ';display: inline-block !important;');

                if(WishlistSettings.style.custom_wishlist_icon) {
                    wishlistBtn[i].setAttribute("data-custom-wishlist-icon", true);
                    wishlistBtn[i].style.right = '10px';
                    wishlistBtn[i].style.left = 'unset';
                    if (!WishlistSettings.style.custom_wishlist_icon_right || WishlistSettings.style.custom_wishlist_icon_right == 'false') {
                        wishlistBtn[i].style.right = 'unset';
                        wishlistBtn[i].style.left = '10px';
                    }
                }
            } else {
                if(WishlistSettings.general.public_wishlist_count === 'show'){
                    wishlistBtn[i].querySelector('.count').classList.add('hulkapps-public-count');
                }
                if(window.hulkappsWishlist.hasAppBlockSupport !== '1') {
                    wishlistBtn[i].classList.add(btnSettings.button_style);
                    wishlistBtn[i].setAttribute("style", btnStyle);
                }
            }
        }

        document.querySelectorAll('.hulkThemeColor').forEach(function (ele) {
            ele.setAttribute('style', 'color: ' + WishlistSettings.style.theme_color);
        });
        document.querySelectorAll('.hulkBtnStyle').forEach(function (ele) {
            ele.setAttribute('style', regularBtns);
        });
        document.querySelectorAll('[data-closewishlistpopup].hulkBtnStyle ').forEach(function (ele) {
            ele.setAttribute('style', regularDenyBtns);
        });
        document.querySelectorAll('[data-closewishlistitemspopup].hulkBtnStyle ').forEach(function (ele) {
            ele.setAttribute('style', regularDenyBtns);
        });
        document.querySelectorAll('[data-closemywishlistpopup].hulkBtnStyle ').forEach(function (ele) {
            ele.setAttribute('style', regularDenyBtns);
        });
        document.querySelectorAll('[data-hulkappsmoveitemscancel].hulkBtnStyle ').forEach(function (ele) {
            ele.setAttribute('style', regularDenyBtns);
        });
        let additionalBtnStyles = document.createElement("style");
        additionalBtnStyles.innerHTML = ".wishlist-btn.style_1 [hulk-wl-custom-style], .wishlist-btn.style_3 [hulk-wl-custom-style], .wishlist-btn.style_5 [hulk-wl-custom-style]{ color: " + WishlistSettings.style.theme_color + "; }\n";
        additionalBtnStyles.innerHTML += ".wishlist-btn.style_2:not([data-gridhulklist]) [hulk-wl-custom-style], .wishlist-btn.style_4:not([data-gridhulklist]) [hulk-wl-custom-style]{ background-color: " + WishlistSettings.style.button_background_color + "; color: " + btnSettings.button_text_color + "; border: " + btnSettings.button_border + "px solid " + btnSettings.button_border_color + "; }\n";
        document.body.appendChild(additionalBtnStyles);
        },
  
    _checkFOrInactiveStore: function(){
        const statusEle = document.querySelectorAll('[data-wishlist-wrapper]')[0];
        if(statusEle == undefined || statusEle == null){
            return;
        }
        let lastUpdateTime = statusEle.getAttribute('data-time');
        if(lastUpdateTime == undefined || lastUpdateTime == null || lastUpdateTime == ''){
            return;
        }

        lastUpdateTime = new Date(statusEle.getAttribute('data-time'));
        const today = new Date();
        const diffTime = Math.abs(today - lastUpdateTime);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if(diffDays >= 30){
            deactivatedStore = true;
        }
    },

    _manageGuestCookie: function(){
        hulkUserUUID = HulkappWishlist._getCookie('hulk_wishlist_UserUUID');
        if(hulkUserUUID == null || hulkUserUUID == undefined || hulkUserUUID.length <= 0){
            hulkUserUUID = null;
        }
    },

 _XMLHttpRequest: function(type, URL, data, domain = null, customerID = null, callback){
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/crypto-js/4.0.0/crypto-js.min.js';
        let newDataRequest = new XMLHttpRequest();
        newDataRequest.open(type, URL, true);
        newDataRequest.setRequestHeader('Accept', 'application/json')
        newDataRequest.setRequestHeader('Content-Type', 'application/json')
        script.onload = function() {
            newDataRequest.setRequestHeader('Encrypt-token', btoa(CryptoJS.SHA256(domain+customerID).toString()));
            if(type == 'GET'){ newDataRequest.send();}
            else{ newDataRequest.send(JSON.stringify(data));}
        };
        newDataRequest.onload = function () {
            callback(newDataRequest.status, this.response)
        }
        document.head.appendChild(script);
    }
  
    /*********************************   End of Functions Used in DOM Manupilation Logic  ********************************/
}

var hulkWishlistPublic = function() {
    return {
        wishlistBtnCheck : function() {
            allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
            if(allHulkWishlistButtons)
                HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
        },
    };
}();

window.addEventListener("load", function(event) {
    HulkappWishlist.init();
    setTimeout(function() {  HulkappWishlist._loadCustomJs(); }, 2000);
});


